import { useEffect } from 'react';

export const BrandingRemover = () => {
  useEffect(() => {
    const removeBranding = () => {
      try {
        // Only target the specific "Made with Emergent" badge
        // Look for the exact text and remove only that element
        const elements = Array.from(document.querySelectorAll('*'));
        
        for (const el of elements) {
          const text = el.textContent?.trim();
          
          // Only remove if it's exactly "Made with Emergent" with minimal children
          if (text === 'Made with Emergent' && el.children.length <= 1) {
            el.remove();
            continue;
          }
          
          // Remove by specific emergent badge attributes
          if (el.getAttribute('data-emergent-badge') === 'true') {
            el.remove();
            continue;
          }
        }
      } catch (e) {
        // Silently fail to not break the app
      }
    };

    // Run a few times to catch the badge when it loads
    const timeouts = [500, 1500, 3000, 5000];
    timeouts.forEach(delay => setTimeout(removeBranding, delay));

    // Check periodically but not too often
    const interval = setInterval(removeBranding, 5000);

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default BrandingRemover;
